import React, { useState } from 'react';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { Badges } from './Badges';

const cardConctentStyles: React.CSSProperties = {
  alignItems: 'left',
  justifyContent: 'left',
  display: 'flex',
  flexDirection: 'column',
};
export const BadgesCard = () => {
  const [hasBadges, setHasBadges] = useState(true);

  const handleBadgeCheck = (badgeCount: number) => {
    setHasBadges(badgeCount > 0);
  };

  if (!hasBadges) {
    return <></>;
  }
  return (
    <Card>
      <CardHeader title="Badges" />
      <Divider />
      <CardContent style={cardConctentStyles}>
        <Badges onBadgeCheck={handleBadgeCheck}></Badges>
      </CardContent>
    </Card>
  );
};
